module.exports = __webpack_public_path__ + "img/Download.38d0287a.svg";